<ejs-multiselect  #multiselect
                  [allowFiltering]="true"
                  [dataSource]="data"
                  [(value)]="outputValue"
                  [width]="width"
                  [enabled]="!isDisabled"
                  [closePopupOnSelect]="closePopupOnSelect"
                  [placeholder]="placeholder"
                  [ngClass]="{'h-auto': outputValue !== null}"
                  [fields]="fieldsSettings">
</ejs-multiselect>
